import styled, { css } from "styled-components";
import { Input } from "antd";

export const StyledInput = styled(Input)`
  border: 0;
  border: ${({ error }) => (error ? "1px solid red" : "1px solid transparent")};
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 16px;
  ::placeholder {
    color: #433f3e;
  }

  :focus {
    outline: none;
    border: ${({ error }) => (error ? "1px solid red" : "1px solid transparent")};
    box-shadow: none;
  }
  :active {
    outline: none;
    border: ${({ error }) => (error ? "1px solid red" : "1px solid transparent")};
    box-shadow: none;
  }
  :hover {
    outline: none;
    border: ${({ error }) => (error ? "1px solid red" : "1px solid transparent")};
    box-shadow: none;
  }
`;
